// extracted by mini-css-extract-plugin
export default {"prompt":"_dbef2128","button":"_537b84fa"};